export { ErrorBoundary } from './lib/ErrorBoundary/ErrorBoundary';
export type { ErrorBoundaryProps } from './lib/ErrorBoundary/ErrorBoundary';
